module.exports = __webpack_public_path__ + "static/media/banner_slider2.328275d3.jpg";